
import ethereum from '../assets/images/Header/ethereum.png';
import fLow from '../assets/images/Header/flow.png';
import tezos from '../assets/images/Header/Tezos.png';
import polygon from '../assets/images/Header/polygon.png';
import binance from '../assets/images/Header/binance.png';

export interface networkSelectDataType {
    id: number,
    logo: any,
    name: string,
    currencyName: string,
    value: number,
    backgroundColor: string,
}

export const networkSelectData: networkSelectDataType[] = [
    {
        id: 1,
        logo: ethereum,
        name: "Ethereum",
        currencyName: 'ETH',
        value: 0.050,
        backgroundColor: '#0044FF',
    },
    {
        id: 2,
        logo: fLow,
        name: "FLow",
        currencyName: 'FLOW',
        value: 0.051,
        backgroundColor: '#00EF8B',
    },
    {
        id: 3,
        logo: tezos,
        name: "Tezos",
        currencyName: 'XTZ',
        value: 0.052,
        backgroundColor: '#3587D9',
    },
    {
        id: 4,
        logo: polygon,
        name: "Polygon",
        currencyName: 'MATIC',
        value: 0.053,
        backgroundColor: '#8247E5',
    },
    {
        id: 5,
        logo: binance,
        name: "Binance",
        currencyName: 'BNB',
        value: 0.0503,
        backgroundColor: '#424848',
    },

]








export interface walletTransactionsDataType {
    id: number,
    ammount: number,
    growing: boolean,
    time: string,
    token: string,
}


export const walletTransactionsData: walletTransactionsDataType[] = [
    {
        id: 1,
        ammount: 0.009,
        growing: true,
        time: '43 minutes ago',
        token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
    },
    {
        id: 2,
        ammount: 0.007,
        growing: true,
        time: '2 hours ago',
        token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
    },
    {
        id: 3,
        ammount: 0.3,
        growing: false,
        time: '4 hours ago',
        token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
    },
    {
        id: 4,
        ammount: 0.00945,
        growing: true,
        time: '5 hours ago',
        token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
    },
    {
        id: 5,
        ammount: 0.009,
        growing: true,
        time: '5 hours ago',
        token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
    },
    {
        id: 6,
        ammount: 0.009,
        growing: true,
        time: '43 minutes ago',
        token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
    },
    {
        id: 7,
        ammount: 0.007,
        growing: true,
        time: '2 hours ago',
        token: '14FuM1aBgcNc4Y5TskDBqhwknVpRnkwjbx',
    },
    {
        id: 8,
        ammount: 0.3,
        growing: false,
        time: '4 hours ago',
        token: '1M5TdPV8G6YfcKkrNEyhPu3nBpWtGXJGho',
    },
    {
        id: 9,
        ammount: 0.00945,
        growing: true,
        time: '5 hours ago',
        token: '1P9RQEr2XeE3PEb44ZE35sfZRRW1JHU8qx',
    },
    {
        id: 10,
        ammount: 0.009,
        growing: true,
        time: '5 hours ago',
        token: '1PRj85hu9RXPZTzxtko9stfs6nRo1vyrQB',
    },
]